import {
  updateIncorrectsDragDrop,
  updateSlideInList,
  setNewCurrentNode,
} from '../../utilities';
import {
  PROTOCOL_SLIDE_TYPES,
  fetchProtocolScene,
  fetchComponentIds,
} from '@learningblocks/protocol-constants/lib/Utilities';
export function slideTwoDragDrop(state, payload) {
  return {
    ...state,
    protocolSection: updateDesignSection(state.protocolSection, payload),
  };
}

function updateDesignSection(protocolSection, payload) {
  const allSlides = updateAllSlides(protocolSection.allSlides, payload);
  return {
    ...protocolSection,
    allSlides,
  };
}

function updateAllSlides(allSlides, payload) {
  const slideTwo = fetchProtocolScene(allSlides, PROTOCOL_SLIDE_TYPES.TWO);
  const designSlideTwo = updateDesignSlideTwo(slideTwo, payload);
  const updatedAllSlides = updateSlideInList(allSlides, designSlideTwo);
  return updatedAllSlides;
}

function updateDesignSlideTwo(designSlideTwo, payload) {
  return {
    ...designSlideTwo,
    incorrects: updateIncorrectsDragDrop(designSlideTwo.incorrects, payload),
    slideTree: updateSlideTree(designSlideTwo.slideTree, payload),
  };
}

function updateSlideTree(slideTree, payload) {
  const updateChangedNode = (node) => ({
    ...node,
    nodeComponents: updateInNodeComponents(node.nodeComponents, payload),
  });

  const updateAllNodes = (node) => {
    if (node.nodeId === payload.nodeId) {
      node = updateChangedNode(node);
    }
    return {...node};
  };

  const updateTreeGroup = (treeGroup) => ({
    ...treeGroup,
    groupNodes: treeGroup.groupNodes.map(updateAllNodes),
  });

  let updatedSlideTree = slideTree.map(updateTreeGroup);
  updatedSlideTree = setNewCurrentNode(updatedSlideTree);
  return updatedSlideTree;
}

function updateInNodeComponents(nodeComponents, payload) {
  const updateInDroppedPostion = () => {
    return nodeComponents.map((component) => {
      if (component.id === payload.positionID) {
        component.droppedId = payload.componentID;
      }
      return {...component};
    });
  };

  const updateInCorrectPosition = () => {
    return nodeComponents.map((component) => {
      if (component.id === payload.componentID) {
        component.droppedId = payload.componentID;
      }
      return {...component};
    });
  };

  const swapItems = (componentList, sourceIndex, targetIndex) => {
    const temp = componentList[sourceIndex];
    componentList[sourceIndex] = componentList[targetIndex];
    componentList[targetIndex] = temp;
    return componentList;
  };

  const sortByDroppedPostion = (nodeComponents) => {
    const componentIndex = nodeComponents.findIndex(
      (comp) => comp.id === payload.componentID
    );
    const positionIndex = nodeComponents.findIndex(
      (comp) => comp.id === payload.positionID
    );
    if (componentIndex === positionIndex) {
      return nodeComponents;
    } else {
      return swapItems(nodeComponents, componentIndex, positionIndex);
    }
  };

  const correctIds = fetchComponentIds(nodeComponents);
  let updatedNodeComponents = [];
  if (correctIds.includes(payload.componentID)) {
    updatedNodeComponents = updateInCorrectPosition();
    updatedNodeComponents = sortByDroppedPostion(updatedNodeComponents);
  } else {
    updatedNodeComponents = updateInDroppedPostion();
  }
  return updatedNodeComponents;
}
